import type { SelectButtonDesignTokens, SelectButtonTokenSections } from '@primeuix/themes/types/selectbutton';

export const root: SelectButtonTokenSections.Root = {
    borderRadius: '{content.borderRadius}'
};

export const colorScheme: SelectButtonTokenSections.ColorScheme = {
    light: {
        root: {
            invalidBorderColor: '{formField.invalidBorderColor}'
        }
    },
    dark: {
        root: {
            invalidBorderColor: '{formField.invalidBorderColor}'
        }
    }
};

export default {
    root,
    colorScheme
} satisfies SelectButtonDesignTokens;